export type OfflineUuidMapState = Record<string, string>; // tempUuid -> realUuid

const STORAGE_KEY = 'offlineUuidMap';

const readState = (): OfflineUuidMapState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return (JSON.parse(raw) as OfflineUuidMapState) || {};
  } catch (e) {
    console.error('Error reading offline uuid map:', e);
    return {};
  }
};

const writeState = (state: OfflineUuidMapState) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error('Error writing offline uuid map:', e);
  }
};

export const setOfflineUuidMapping = (tempUuid: string, realUuid: string) => {
  const state = readState();
  writeState({
    ...state,
    [tempUuid]: realUuid,
  });
};

export const resolveOfflineUuid = (uuid: string) => {
  const state = readState();
  return state[uuid] || uuid;
};

export const getOfflineUuidMap = () => readState();

export const clearOfflineUuidMap = () => writeState({});
